import axios from 'axios';

const state = {
  techcards: [],
  editionTypes: [],
  projectManagers: [],
  workTypes: [],
  authors: [],
  application: null,
  offerId: 0, // Добавьте это
  techcardForEdit: null,
  loading: false,
  error: null,
  addModal: false,
  editModal: false,
  signalModal: false,
  editSignal: null,
  printModal: false,
  editPrint: null,
  changeStatusModal: false,
  applicationId: null, // Add this to store the application ID
  publishModal: false,
techcardForPublish: null,
metadataModal: false,                // ← новое
  techcardIdForMetadata: null,         // ← новое
  extractedMetadata: {                 // ← новое (по желанию хранить в сторе)
    isbn: '',
    udk: '',
    bbk: '',
  },
  
};

const getters = {
  metadataModal: (s) => s.metadataModal,
  techcardIdForMetadata: (s) => s.techcardIdForMetadata,
  extractedMetadata: (s) => s.extractedMetadata,
  techcards: (state) => state.techcards,
  editionTypes: (state) => state.editionTypes,
  projectManagers: (state) => state.projectManagers,
  workTypes: (state) => state.workTypes,
  authors: (state) => state.authors,
  application: (state) => state.application,
  techcardForEdit: (state) => state.techcardForEdit,
  loading: (state) => state.loading,
  error: (state) => state.error,
  addModal: (state) => state.addModal,
  editModal: (state) => state.editModal,
  signalModal: (state) => state.signalModal,
  editSignal: (state) => state.editSignal,
  printModal: (state) => state.printModal,
  editPrint: (state) => state.editPrint,
  changeStatusModal: (state) => state.changeStatusModal,
  techcardForPreview: (state) => state.techcardForPreview,  // Ensure this is populated correctly
  publishModal: (state) => state.publishModal,
techcardForPublish: (state) => state.techcardForPublish,
};

const actions = {
   async openMetadataModal({ commit, dispatch }, techcardId) {
    commit('OPEN_METADATA_MODAL', techcardId);
    // если нужно — загрузим ту же теккарту, что и для publish
  },
  closeMetadataModal({ commit }) { commit('CLOSE_METADATA_MODAL'); },

  async fetchTechcardForPublish({ commit }, techcardId) {
    commit('setLoading', true);
    try {
      const token = localStorage.getItem('token');
      const { data } = await axios.get(`https://apidash.smartpress.kz/api/tech-cards/${techcardId}/edit`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      commit('setEditionTypes', data.editionTypes);
      commit('setProjectManagers', data.projectManagers);
      commit('setWorkTypes', data.workTypes);
      commit('setAuthors', data.authors);
      commit('setTechcardForPublish', data.techCard); // <-- только сюда
      commit('setPublishModal', true);               // <-- открываем ПУБЛИКАЦИЮ
    } catch (error) {
      commit('setError', error);
    } finally {
      commit('setLoading', false);
    }
  },
   async publishToInstagram({ }, techcardId) {
      const token = localStorage.getItem('token');
      const url = `https://apidash.smartpress.kz/api/social/instagram/publish/techcards/${techcardId}`;
      const { data } = await axios.post(url, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return data;
    },

  openPublishModal({ commit }) { commit('setPublishModal', true); },
  closePublishModal({ commit }) { commit('setPublishModal', false); },
  // store/modules/techcards.js (фрагмент экшена submitPublishToShop)
async submitPublishToShop({ commit, rootGetters }, { form, techcardId }) {
  commit('setLoading', true);
  try {
    const token = localStorage.getItem('token');
    const fd = new FormData();

    fd.append('external_techcard_id', techcardId);
    fd.append('organization_id', String(form.publish_house || ''));
    fd.append('name', form.name || '');
    fd.append('isbn', form.isbn || '');
    fd.append('slug', form.slug || '');
    fd.append('publish_date', form.publish_date || '');
    fd.append('description', form.description || '');
    fd.append('price_soft', form.price_soft ?? '');
    fd.append('price_hard', form.price_hard ?? '');
    fd.append('price_ebook', form.price_ebook ?? '');
    fd.append('featured', form.featured ? '1' : '0');
    fd.append('bestseller', form.bestseller ? '1' : '0');
    fd.append('category_id', form.category_id ?? '');
    (form.author_ids || []).forEach(id => fd.append('author_ids[]', id));

    // файлы (если выбраны)
    if (form.image)   fd.append('image', form.image);
    if (form.content) fd.append('content', form.content);

     // Authors: send full author objects
    form.authors.forEach((a, i) => {
      if (a.name_ru)      fd.append(`authors[${i}][name_ru]`, a.name_ru);
      if (a.description)  fd.append(`authors[${i}][description]`, a.description);
      if (a.src_avatar)   fd.append(`authors[${i}][src_avatar]`, a.src_avatar);
    });

    // FALLBACK: если файлов нет — передаём исходники техкарты
    // techcard.src_cover -> image; techcard.src_fpage -> content
    const tc = rootGetters['techcards/techcardForPublish']; // доступ к текущей техкарте
    if (!form.image && tc?.src_cover)   fd.append('src_cover', tc.src_cover);
    if (!form.content && tc?.src_fpage) fd.append('src_fpage', tc.src_fpage);

    await axios.post('https://apidash.smartpress.kz/api/products/sync', fd, {
      headers: { 'Authorization': `Bearer ${token}` }
    });

    commit('setPublishModal', false);
  } catch (error) {
    commit('setError', error);
    throw error;
  } finally {
    commit('setLoading', false);
  }
},


  async fetchArchivedTechCards({ commit }) {
  commit('setLoading', true);
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get('https://apidash.smartpress.kz/api/tech-cards', {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    // Фильтрация архивированных техкарт
    const archivedTechcards = response.data.techcards.filter(tc => tc.is_archieve === 1);

    commit('setTechCards', archivedTechcards);
    console.log("Fetched Archived Techcards:", archivedTechcards);
  } catch (error) {
    commit('setError', error);
  } finally {
    commit('setLoading', false);
  }
},
  async fetchTechCards({ commit }) {
  commit('setLoading', true);
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get('https://apidash.smartpress.kz/api/tech-cards', {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    let techcards = response.data.techcards || [];

    const activeUser = JSON.parse(localStorage.getItem('activeUser')) || {};
    const roleId = Number(activeUser.role_id || 0);
    const restrictedRoles = [4, 6, 8];

    if (restrictedRoles.includes(roleId)) {
      techcards = techcards.filter(tc =>
        tc.status !== 'archieve' &&
        (tc.is_archieve === 0 || tc.is_archieve === '0' || tc.is_archieve == null)
      );
    }
    

    commit('setTechCards', techcards);
    console.log('Fetched Techcards:', techcards);
  } catch (error) {
    commit('setError', error);
  } finally {
    commit('setLoading', false);
  }
},
  async fetchInitialData({ commit }, applicationId) {
    commit('setLoading', true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`https://apidash.smartpress.kz/api/tech-cards/create?applicationId=${applicationId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      commit('setEditionTypes', response.data.editionTypes);
      commit('setProjectManagers', response.data.projectManagers);
      commit('setWorkTypes', response.data.workTypes);
      commit('setAuthors', response.data.authors);
      commit('setApplication', response.data.application);
    } catch (error) {
      commit('setError', error);
    } finally {
      commit('setLoading', false);
    }
  },
  async createTechCard({ commit, dispatch }, techCardData) {
    commit('setLoading', true);
    try {
      const token = localStorage.getItem('token');
      await axios.post('https://apidash.smartpress.kz/api/tech-cards/create', techCardData, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      dispatch('fetchTechCards'); // Fetch the latest list after creation
    } catch (error) {
      commit('setError', error);
      throw error;
    } finally {
      commit('setLoading', false);
    }
  },
  async updateTechCard({ commit, dispatch }, { formData, id }) {
    commit('setLoading', true);
    try {
      const token = localStorage.getItem('token');
      await axios.post(`https://apidash.smartpress.kz/api/tech-cards/${id}/edit`, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
          // 'Content-Type': 'multipart/form-data', // Ensure the content type is correct for FormData
        }
      });
      dispatch('fetchTechCards'); // Fetch the latest list after creation
    } catch (error) {
      commit('setError', error);
      throw error;
    } finally {
      commit('setLoading', false);
    }
  },
  async fetchTechcardForEdit({ commit }, techcardId) {
    commit('setLoading', true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`https://apidash.smartpress.kz/api/tech-cards/${techcardId}/edit`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      commit('setEditionTypes', response.data.editionTypes);
      commit('setProjectManagers', response.data.projectManagers);
      commit('setWorkTypes', response.data.workTypes);
      commit('setAuthors', response.data.authors);
      commit('setTechcardForEdit', response.data.techCard);
      commit('setEditModal', true);
    } catch (error) {
      commit('setError', error);
    } finally {
      commit('setLoading', false);
    }
  },
  async fetchTechcardForPreview({ commit }, techcardId) {
    commit('setLoading', true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`https://apidash.smartpress.kz/api/tech-cards/${techcardId}/edit`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      // You don't need to commit mutations that open the edit modal.
      commit('setEditionTypes', response.data.editionTypes);
      commit('setProjectManagers', response.data.projectManagers);
      commit('setWorkTypes', response.data.workTypes);
      commit('setAuthors', response.data.authors);
      commit('setTechcardForPreview', response.data.techCard);
    } catch (error) {
      commit('setError', error);
    } finally {
      commit('setLoading', false);
    }
  },
  openTechCardApplication: async ({ dispatch, commit }, applicationId) => {
    // Fetch initial data before opening the modal
    await dispatch('fetchInitialData', applicationId);
    
    // Now open the modal
    commit('SET_APPLICATION_ID', applicationId);
    commit('setAddModal', true);
  },
  closeTechCardModal({ commit }) {
    commit('setAddModal', false);
    commit('setEditModal', false);
  },
  openChangeStatusModal({ commit }) {
    commit('setChangeStatusModal', true);
  },
  closeChangeStatusModal({ commit }) {
    commit('setChangeStatusModal', false);
  },
  openSignalCopy({ commit }, { techCardId, signalData }) {
    commit('setSignalModal', true); // This is correct since it's inside the module
    commit('setEditSignal', { techCardId, signalData });
  },
  closeSignalCopy({ commit }) {
    commit('setSignalModal', false);
  },
  openPrintModal({ commit }, { techCardId, signalData }) {
    commit('setPrintModal', true);
    commit('setEditPrint', { techCardId, signalData });
  },
  closePrintModal({ commit }) {
    commit('setPrintModal', false);
  },
};

const mutations = {
  SET_METADATA_MODAL(state, v) { state.metadataModal = !!v; },
  SET_TECHCARD_ID_FOR_METADATA(state, id) { state.techcardIdForMetadata = id; },
  SET_EXTRACTED_METADATA(state, meta) { state.extractedMetadata = meta || {}; },

  OPEN_METADATA_MODAL(state, techcardId) {
    state.metadataModal = true;
    state.techcardIdForMetadata = techcardId;
  },
  CLOSE_METADATA_MODAL(state) {
    state.metadataModal = false;
    state.techcardIdForMetadata = null;
    state.extractedMetadata = { isbn:'', udk:'', bbk:'' };
  },
  SET_EXTRACTED_METADATA(state, payload) {
    state.extractedMetadata = { ...state.extractedMetadata, ...payload };
  },
  setOfferId(state, id) {
    state.offerId = id;
},
  setTechCards(state, techcards) {
    state.techcards = techcards;
  },
  setEditionTypes(state, editionTypes) {
    state.editionTypes = editionTypes;
  },
  setProjectManagers(state, projectManagers) {
    state.projectManagers = projectManagers;
  },
  setWorkTypes(state, workTypes) {
    state.workTypes = workTypes;
  },
  setAuthors(state, authors) {
    state.authors = authors;
  },
  setApplication(state, application) {
    state.application = application;
  },
  setTechcardForEdit(state, techcard) {
    state.techcardForEdit = techcard;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setError(state, error) {
    state.error = error;
  },
  SET_APPLICATION_ID(state, applicationId) {
    state.applicationId = applicationId; // Store the application ID
  },
  setAddModal(state, status) {
    state.addModal = status;
  },
  setSignalModal(state, status) {
    state.signalModal = status;
  },
  setPrintModal(state, status) {
    state.printModal = status;
  },
  setEditSignal(state, { techCardId, signalData }) {
    state.editSignal = { techCardId, signalData };
  },
  setEditPrint(state, { techCardId, signalData }) {
    state.editPrint = { techCardId, signalData };
  },
  setEditModal(state, editModal) {
    state.editModal = editModal;
  },
  setChangeStatusModal(state, changeStatusModal) {
    state.changeStatusModal = changeStatusModal;
  },
  setTechcardForPreview(state, techcard) {
    state.techcardForPreview = techcard;
  },
  setPublishModal(state, val) { state.publishModal = val; },
  setTechcardForPublish(state, techcard) { state.techcardForPublish = techcard; },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
